import React from 'react';

import { Box, Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  Stack, HeaderText, BodyText, Separator, Button,
} from '../../../../ui';

import { VariousRocketIcon, BasicEyeIcon, TimeTimerIcon } from '../../../../ui/Icons';

import FireStarsGradient from '../../../../ui/Icons/FireStarsGradient';

import useMount from '../../../../../hooks/useMount';

import ProgressBar from '../ProgressBar';

import PortalOverlay, {
  PortalOverlayModal,
  PortalOverlayHeader,
  PortalOverlayHeaderCloseBtn,
} from '../../../../ui/PortalOverlay';

type InfoModalProps = {
  currentValue?: number;
  cta?: {
    text: string;
    onClick: () => void;
  };
  progressDisabled?: boolean;
  closeModal: (event: string) => void;
  onOpen: () => void;
};
const InfoModal: React.FC<InfoModalProps> = ({
  closeModal,
  currentValue,
  cta,
  progressDisabled,
  onOpen,
}) => {
  useMount(() => onOpen());

  return (
    <PortalOverlay
      onBackdropClick={() => closeModal('dismiss_click')}
      name="whatisboost-modal"
    >
      <PortalOverlayModal
        position="fullScreen"
        color={colors.chill}
      >
        <PortalOverlayHeader
          renderRightAction={() => (
            <PortalOverlayHeaderCloseBtn
              onCloseRequest={() => closeModal('dismiss_click')}
              testID="whatisboost-modal-close-button"
            />
          )}
        />
        <Stack alignItems="center" paddingY={20} space={12}>
          <FireStarsGradient style={{ marginBottom: 16 }} />
          <HeaderText level={1} style={{ fontWeight: '300', fontSize: 36, lineHeight: 30 }}>What is a</HeaderText>
          <HeaderText level={1} style={{ fontSize: 36, lineHeight: 30 }}>Search Boost?</HeaderText>
        </Stack>
        <Box justifyContent="center" alignItems="center">
          <Stack space={24} paddingX={20} maxWidth={400}>
            <Inline
              space={16}
              alignItems="center"
            >
              <VariousRocketIcon
                width={24}
                height={24}
                color={colors.slate}
                style={{ flexShrink: 0 }}
              />
              <BodyText appearance="small">
                Search boost pushes your profile to the top of client searches in your area
              </BodyText>
            </Inline>
            <Inline
              space={16}
              alignItems="center"
            >
              <BasicEyeIcon
                width={24}
                height={24}
                color={colors.slate}
                style={{ flexShrink: 0 }}
              />
              <BodyText appearance="small">
                Boosted profiles get up to
                <BodyText appearance="small" weight="bold"> 40% more page views and 2x the new client appointments
                </BodyText>
              </BodyText>
            </Inline>
            <Inline
              space={16}
              alignItems="center"
            >
              <TimeTimerIcon
                width={22}
                height={22}
                color={colors.slate}
                handColor={colors.slate}
                style={{ flexShrink: 0 }}
              />
              <BodyText appearance="small">
                The Boost lasts for 7 days!
              </BodyText>
            </Inline>
            <Separator appearance="extrathin" color={colors.slate} style={{ opacity: 0.1 }} />
            <Box paddingX={48}>
              <HeaderText
                level={3}
                textAlign="center"
              >
                Book 6 appointments to earn a Search Boost
              </HeaderText>
            </Box>
          </Stack>
        </Box>
        <ProgressBar
          currentValue={currentValue}
          disabled={progressDisabled}
          backgroundColor={progressDisabled ? colors.silver : colors.whiteWash}
          hideCount={!!progressDisabled}
        />
        <Stack alignItems="center" justifyContent="space-between" paddingY={16} flex={1}>
          {cta && (
            <Button
              testID="whatisboost-modal-cta"
              onClick={cta.onClick}
              style={{ marginTop: 8 }}
            >
              {cta.text}
            </Button>
          )}
          {!cta && (
            <Box maxWidth={240}>
              <BodyText textAlign="center" color={colors.slate}>Set up your services, photos, and availability to unlock!</BodyText>
            </Box>
          )}
          <Button
            testID="whatisboost-modal-thanks-button"
            appearance="link"
            onClick={() => closeModal('thanks_click')}
          >
            Got it, Thanks
          </Button>
        </Stack>
      </PortalOverlayModal>
    </PortalOverlay>
  );
};

export default InfoModal;
